import { callApiToServer } from "../callApi";

export async function editCourse(authtoken, courseObject, courseId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(courseObject);

    console.log("== body oebkect", body)

    let endUrl = "v1/auth/admin/edit-course";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
